import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { PatientDashboardComponent } from '../../patients/dashboard-page/dashboard-page.component';

@Injectable({ providedIn: 'root' })
export class DashboardCanDeactivateGuard implements CanDeactivate<PatientDashboardComponent> {
  canDeactivate(component: PatientDashboardComponent): boolean {
    // Call the flush method on the dashboard, which will call vitalsTab.flushPendingVitals('route-leave')
    component.vitalsTab?.flushPendingVitals('route-leave');
    // Always allow navigation (return true). If you want to block on unsaved, return a boolean or prompt.
    return true;
  }
}